import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { getBackendHost } from '@segment/tracking/scripts';
import { getCookie } from '../../tracking/scripts/cookies';
export var USER_PROFILE_COOKIE = "user-profile-enabled";
export var fetchUserRegisteredByEmail = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(signal, options) {
    var eventName, formId, email, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            eventName = options.eventName, formId = options.formId, email = options.email;
            _context.next = 3;
            return fetch("".concat(getBackendHost(window.location.host, window.location.protocol), "/backend/profile/").concat(eventName, "/").concat(formId), {
              method: "POST",
              headers: {
                'Content-Type': "application/json"
              },
              body: JSON.stringify({
                email: email
              }),
              signal: signal
            }).then(function (res) {
              return res.json();
            })["catch"](function (err) {
              return err.message;
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchUserRegisteredByEmail(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Decided to not check the endpoint or even the cookie value at this time.
 * The content is public anyways, however if we decide to `gate` the content we will need to make
 * this a HTTP cookie and control all data coming form /backend using this cookie.
 * Right now this function is just creating a cookie in the BE to be read in the FE through `useCookie`
 * @param email user email
 * @returns success or error message from server
 */
export var fetchProfileCookie = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(signal, email) {
    var successMessage, errorMessage, jwt;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            successMessage = "user logged in";
            errorMessage = "user not logged in";

            if (!getCookie(USER_PROFILE_COOKIE)) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", successMessage);

          case 4:
            _context2.next = 6;
            return fetch("".concat(getBackendHost(window.location.host, window.location.protocol), "/backend/profile/auth"), {
              method: "POST",
              headers: {
                'Content-Type': "application/json"
              },
              body: JSON.stringify({
                email: email
              }),
              signal: signal
            }).then(function (res) {
              return res.json();
            })["catch"](function () {
              return errorMessage;
            });

          case 6:
            jwt = _context2.sent;
            return _context2.abrupt("return", jwt.message || "");

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchProfileCookie(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();